import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from './HoiPoiProvider';

/** SVG linearGradient defs using the shared promotional stop colors. */
function PromoGradientDefs({ id }) {
    const theme = useTheme();

    return (
        <defs>
            <linearGradient id={id} x1="0" y1="0" x2="1" y2="0">
                <stop offset="0%" stopColor={theme.colors.utility.promoGradientGreen} />
                <stop offset="50%" stopColor={theme.colors.utility.promoGradientBlue} />
                <stop offset="100%" stopColor={theme.colors.utility.promoGradientPurple} />
            </linearGradient>
        </defs>
    );
}

PromoGradientDefs.propTypes = {
    /** Unique id referenced by fill={`url(#${id})`} */
    id: PropTypes.string.isRequired,
};

export default PromoGradientDefs;
